//
// RelationalDataProvider.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataProvider";
import "@sas-dvr/ltjs-commons/models/data/dataset/RowStates";

var RelationalDataProvider = createModule("gtl::RelationalDataProvider", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::DataProvider"], EventDispatcher, [
    ,
    {
        rowStates: 1,
        sortedIndicies: [3],
    },
    ,
    ,
    ,
    ,
    ,
]);
export default RelationalDataProvider;
